
import { CoreSetting, GeneralSettingsOutput, SettingsService } from 'src/app/pages/settings/settings.service';
import { Component, Input, OnInit } from '@angular/core';
import { ConsoleService } from 'src/app/services/console.service';

@Component({
    selector: 'app-settings-renderer',
    templateUrl: './settings-renderer.component.html',
    styleUrls: ['./settings-renderer.component.scss'],
    standalone: false
})
export class SettingsRendererComponent implements OnInit {

	private _dataSource: CoreSetting[];
	public get dataSource(): CoreSetting[] {
		return this._dataSource;
	}
	@Input()
	public set dataSource(value: CoreSetting[]) {
		this._dataSource = value;

		if (this._dataSource) {
			for (let a = 0; a < this._dataSource.length; a++) {
				const coreSetting: CoreSetting = this._dataSource[a];

				coreSetting.initializeSelectionItems();

				
			}

		}
	}

	public onRowUpdated(evt: any): void {
		console.error("onRowUpdated", evt);

		
	}

	public onSaved(evt: any): void {
		console.error("onSaved", evt);

		const generalSettingsOutput: GeneralSettingsOutput[] = [];

		for (let a = 0; a < evt.changes.length; a++) {
			const setting = evt.changes[a];

			generalSettingsOutput.push(
				new GeneralSettingsOutput(
					setting.data.settingId,
					setting.data.listId,
					setting.data.value,
					setting.data.description
				)
			);
		}

		this._settingsService.saveGeneralSettings(
			generalSettingsOutput,
			{
				showLoadingIndicator: true,
				responseLoggingEnabled: false,
			}
		).subscribe(
			{
				next: (response) => {
				}
			}
		);
	}

	public logValue(evt: any): void {
		console.error("logged", evt);
	}

	constructor(
		private _settingsService: SettingsService,
		public consoleService: ConsoleService,
	) { }

	ngOnInit(): void {
	}
}
